import { getValidToken } from '../utils/tokenUtils';
import { apiRequest } from './apiHelpers';

export const fetchContractsByTester = async (email, organisationId) => {
  const token = await getValidToken();
  const res = await fetch(`/api/serviceorder/tester?email=${encodeURIComponent(email)}&organisationId=${encodeURIComponent(organisationId)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunde inte hämta testerens kontrakt.');
  return res.json();
};

export const createServiceOrder = async (serviceNowId, organisationId, contractIds, testerEmails, tpvIssueKey, testingOrganisationId = null) => {
  const token = await getValidToken();
  const payload = {
    serviceNowId,
    organisationId,
    contractIds,
    testerEmails,
    tpvIssueKey: tpvIssueKey || null,
    testingOrganisationId: testingOrganisationId || null,
  };

  const res = await fetch('/api/serviceorder', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    const err = new Error(errorData?.message || 'Något gick fel vid skapandet av beställningen.');
    err.status = res.status;
    throw err;
  }

  return res.json();
};

export const fetchSourceSystemOptions = async () => {
  const token = await getValidToken();
  const res = await fetch('/api/serviceorder/source-systems', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunde inte hämta källsystem.');
  return res.json();
};

export const fetchServiceOrderGroups = async (organisationId = null) => {
  const query = organisationId ? `?organisationId=${encodeURIComponent(organisationId)}` : '';
  const data = await apiRequest(`/api/serviceorder/groups${query}`);
  return Array.isArray(data) ? data : [];
};

export const fetchServiceOrderGroup = (serviceNowId, organisationId) =>
  apiRequest(`/api/serviceorder/group?serviceNowId=${encodeURIComponent(serviceNowId)}&organisationId=${encodeURIComponent(organisationId)}`);

export const updateServiceOrderGroup = (
  { organisationId, originalServiceNowId, serviceNowId, contractIds, testerEmails, sourceSystem, serviceProvider }
) =>
  apiRequest('/api/serviceorder/group', {
    method: 'PUT',
    body: JSON.stringify({
      organisationId,
      originalServiceNowId,
      serviceNowId,
      contractIds,
      testerEmails,
      sourceSystem,
      serviceProvider: serviceProvider || null,
    }),
  });

export const deleteServiceOrderGroup = (serviceNowId, organisationId) =>
  apiRequest(
    `/api/serviceorder/group?serviceNowId=${encodeURIComponent(serviceNowId)}&organisationId=${encodeURIComponent(organisationId)}`,
    { method: 'DELETE' }
  );
